<template>
  <b-modal ref="AdditionalCostModal" :no-close-on-backdrop="true">
    <div>
      <b-row>
        <b-col offset="2" cols="8">
          <label>{{$t('modal_dialogs.additional_cost.value_type')}}</label>
          <multiselect v-model="additionalCost.cost_type" :max-height="200" label="name" :options="valueTypes"
                       placeholder="Choose value type" :class="{ required: !additionalCost.cost_type}">
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="2" cols="8">
          <label>{{$t('labels.common.value')}}</label>
          <input class="form-control" v-model.number="additionalCost.cost" placeholder="Enter value"
                 :class="{ required: !additionalCost.cost}">
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="2" cols="8">
          <label>{{$t('labels.common.type')}}</label>
          <multiselect v-model="additionalCost.type" :max-height="200"
                       placeholder="Choose type of cost" label="name" track-by="name"
                       :options="typeOptions" :class="{ required: !additionalCost.type}"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="2" cols="8">
          <label>{{$t('labels.common.name')}}</label>
          <input class="form-control" v-model="additionalCost.name" placeholder="Enter name of cost">
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="2" cols="8">
          <label>{{$t('common_content.partner')}}</label>
          <multiselect v-model="additionalCost.partner" :max-height="200" placeholder="Choose partner"
                       label="name" track-by="name" :options="partners"></multiselect>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 text-center">
      <b-btn size="sm" variant="success" @click="saveAdditionalCost">
        {{$t('buttons.common.save')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import { setNotifyData, handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  export default {
    props: ['operationId', 'fetchCallback'],
    components: {
      Multiselect
    },
    data() {
      return {
        additionalCostInitial: {
          cost_type: null,
          name: '',
          movement: '',
          partner: null,
          cost: '',
          type: null
        },
        additionalCost: {},
        valueTypes: [{name: '%'}, {name: '€'}],
        typeOptions: [{name: 'Transport'}, {name: 'Commission'}, {name: 'Other'}]
      }
    },
    methods: {
      saveAdditionalCost() {
        const loader = this.$loading.show();
        const payload = {
          acceptance: this.operationId,
          name: this.additionalCost.name,
          cost: this.additionalCost.cost,
          cost_type: this.additionalCost.cost_type && this.additionalCost.cost_type.name,
          type: this.additionalCost.type && this.additionalCost.type.name,
          partner: this.additionalCost.partner && this.additionalCost.partner.id
        };
        if (this.additionalCost.isNew) {
          this.$http.post(`woodware/acceptance_additional_costs/`, payload).then(handlerResponse).then(() => {
            this.$refs['AdditionalCostModal'].hide();
            this.$notify(setNotifyData('Success', 'Additional cost has been created!', 'success'));
            this.fetchCallback(false);
            loader.hide();
          }).catch(error => {
            notificationsRenderer(error.data, 'error');
            loader.hide();
          })
        } else {
          const costId = this.additionalCost.id;
          this.$http.put(`woodware/acceptance_additional_costs/${costId}/`, payload).then(handlerResponse).then(() => {
            this.$refs['AdditionalCostModal'].hide();
            this.$notify(setNotifyData('Success', 'Additional cost has been updated!', 'success'));
            this.fetchCallback(false);
            loader.hide();
          }).catch(error => {
            notificationsRenderer(error.data, 'error');
            loader.hide();
          });
        }
      }
    },
    computed: {
      ...mapState('woodware', ['partners']),
    },
    mounted() {
      this.$root.$on('openAdditionalCostModal', (data) => {
        this.additionalCost = {...this.additionalCostInitial, ...data};
        if (this.$refs['AdditionalCostModal']) {
          this.$refs['AdditionalCostModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openAdditionalCostModal');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/AdditionalCost.vue